import { render, staticRenderFns } from "./BitfinexExchangeInput.vue?vue&type=template&id=57fa37a2&"
import script from "./BitfinexExchangeInput.vue?vue&type=script&lang=ts&"
export * from "./BitfinexExchangeInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports